import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";
import { Icons } from "assets";
import { TextCus } from "components/TextCus";

const CustomSelect = styled(Select)(() => ({
  backgroundColor: "#F5F5F5",
  borderRadius: "5px",
  zIndex: "999",
  height: "40px",

  "& .MuiSelect-select.MuiSelect-standard.MuiInputBase-input.MuiInput-input": {
    paddingRight: "0px !important",
  },
  "& .MuiInputBase-root.MuiInput-root.MuiInput-underline": {
    "::before": {
      content: "none",
    },
    "::after": {
      content: "none",
    },
  },
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    display: "none !important",
  },
  "& .MuiSelect-icon": {
    color: "#3F51B5",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  padding: "10px 16px",
}));

interface CommonSelectProps {
  options?: {
    id: string;
    name: string;
    childrens: { id: string; name: string }[];
  }[];
  value?: string;
  onChange?: (event: SelectChangeEvent<any>) => void;
  width?: string;
  label?: string;
  titleTooltip?: string;
  action?: () => void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

const SelectGroupCus = ({
  options,
  value,
  onChange,
  width,
  label,
  titleTooltip,
  action,
  ...selectProps
}: CommonSelectProps) => {
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <CustomSelect
        IconComponent={() => <Box pl={"5px"}>{Icons.ArrowSelect()}</Box>}
        displayEmpty
        onChange={onChange}
        MenuProps={MenuProps}
        value={value}
        renderValue={(selected: string) => {
          if (!selected) {
            return <em>{label}</em>;
          }
          // Check top-level items first
          const topLevel = options?.find((item) => item.id === selected);
          if (topLevel) return topLevel.name;
          // Check child items
          for (const item of options || []) {
            const child = item.childrens.find((v) => v.id === selected);
            if (child) return child.name;
          }
          return <em>{label}</em>; // fallback
        }}
        {...selectProps}
      >
        {label && (
          <MenuItem
            value=""
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {action ? (
              <Button
                fullWidth
                onClick={action}
                size="small"
                variant="outlined"
              >
                <TextCus sx={{ fontSize: "12px" }}>Tạo mới</TextCus>
              </Button>
            ) : (
              <em style={{ fontSize: "13px", width: "100%" }}>{label}</em>
            )}
          </MenuItem>
        )}
        {options?.map((item) =>
          item.childrens?.length === 0 ? (
            <MenuItem value={item.id} key={item.id}>
              {item.name}
            </MenuItem>
          ) : (
            <React.Fragment key={item.id}>
              <ListSubheader
                sx={{ bgcolor: "#F5F5F5", height: "40px", lineHeight: "40px" }}
              >
                {item.name}
              </ListSubheader>
              {item?.childrens?.map((v) => (
                <MenuItem key={v.id} value={v.id}>
                  {v.name}
                </MenuItem>
              ))}
            </React.Fragment>
          )
        )}
      </CustomSelect>
    </FormControl>
  );
};

export default SelectGroupCus;
